import { useEffect, useState } from "react";
import { navItems } from "@/mocks/homeContent";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className="fixed inset-x-0 top-0 z-50">
      <nav
        className={`transition-all duration-300 ${
          scrolled
            ? "bg-background-50/95 backdrop-blur border-b border-background-200"
            : "bg-transparent border-b border-transparent"
        }`}
      >
        <div className="mx-auto flex h-16 md:h-[72px] max-w-7xl items-center justify-between px-4 md:px-8">
          <a
            href="#home"
            className="flex items-center gap-2 whitespace-nowrap"
            aria-label="曝光导航 返回首页"
          >
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-600 text-background-50">
              <i className="ri-radio-fill text-lg"></i>
            </span>
            <span
              className={`font-display text-xl font-bold tracking-tight ${
                scrolled ? "text-foreground-950" : "text-background-50"
              }`}
            >
              曝光导航
            </span>
          </a>

          <div className="hidden items-center gap-1 lg:flex">
            {navItems.map((item) => (
              <a
                key={item.key}
                href={item.href}
                className={`rounded-md px-3 py-2 text-sm whitespace-nowrap transition-colors ${
                  scrolled
                    ? "text-foreground-700 hover:bg-background-100 hover:text-primary-700"
                    : "text-background-100 hover:bg-white/10 hover:text-white"
                }`}
              >
                {item.label}
              </a>
            ))}
            <a
              href="#contact"
              className="ml-2 inline-flex items-center gap-2 rounded-md bg-primary-600 px-4 py-2 text-sm font-medium text-background-50 whitespace-nowrap transition-colors hover:bg-primary-700"
            >
              提交线索
              <i className="ri-arrow-right-up-line"></i>
            </a>
          </div>

          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label={open ? "关闭菜单" : "打开菜单"}
            className={`flex h-10 w-10 items-center justify-center rounded-md lg:hidden ${
              scrolled
                ? "text-foreground-950 bg-background-100"
                : "text-background-50 bg-white/10"
            }`}
          >
            <i className={`text-xl ${open ? "ri-close-line" : "ri-menu-line"}`}></i>
          </button>
        </div>

        {open && (
          <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 lg:hidden">
            {navItems.map((item) => (
              <a
                key={item.key}
                href={item.href}
                onClick={() => setOpen(false)}
                className="block rounded-md px-3 py-2.5 text-sm text-foreground-700 hover:bg-background-100"
              >
                {item.label}
              </a>
            ))}
          </div>
        )}
      </nav>
    </header>
  );
}